// Bug Report Configuration
export const BUG_REPORT_CONFIG = {
  // Google Forms Configuration
  GOOGLE_FORMS: {
    ENABLED: true,
    FORM_URL: 'https://docs.google.com/forms/d/e/1FAIpQLSc-ZlElw_VOVDx586PJgY0mtU_zmXQSh5RRXmlduxhXmVrDjQ/formResponse', // Replace with your actual form URL
    FIELD_IDS: {
      MESSAGE: 'entry.1573890514',
      USER_NAME: 'entry.896890243',
      USER_EMAIL: 'entry.1399583915',
      URL: 'entry.1011693273',
      TIMESTAMP: 'entry.1596272791'
    }
  },
  
  // Webhook Configuration (for testing)
  WEBHOOK: {
    ENABLED: false,
    URL: 'https://webhook.site/your-webhook-url'
  },
  
  // EmailJS Configuration
  EMAILJS: {
    ENABLED: false,
    SERVICE_ID: 'your-service-id',
    TEMPLATE_ID: 'your-template-id',
    PUBLIC_KEY: 'your-public-key'
  }
};
